import { render, staticRenderFns } from "./RemoveUserModal.vue?vue&type=template&id=3c559b3e&"
import script from "./RemoveUserModal.vue?vue&type=script&lang=js&"
export * from "./RemoveUserModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveUserModal.vue?vue&type=style&index=0&id=3c559b3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports